import { Action } from '@agile-actors/actions/js';

const namespaceAction = Action('@@UI/SIDEBAR');

const toggleSidebar = namespaceAction('TOGGLE');
const openSidebar = namespaceAction('OPEN');
const closeSidebar = namespaceAction('CLOSE');

export { toggleSidebar, openSidebar, closeSidebar };
